<template>
	<div class="memo">
		<div class="form">
			<el-form :model="form" ref="form" label-width="160px" class="demo-ruleForm">
				<el-form-item label="订单编号">
					<div>{{checkobj.trade_no}} <span style="margin-left: 20px">订单状态:
							{{checkobj.order_status_str}}</span></div>
				</el-form-item>
				<el-form-item label="标记" class="colorradio">
					<el-radio-group v-model="form.mark">
						<el-radio :label="v.id" v-for="(v,k) in appdata.list.mark" :key="k">
							<div class="colorbox" :style="'background-color:'+v.color"></div>
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="备注">
					<el-input type="textarea" placeholder="" v-model="form.memo" maxlength="500" show-word-limit
						:rows="4">
					</el-input>
				</el-form-item>
				<el-form-item label="备注查看设置">
					<el-radio-group v-model="form.memo_show">
						<el-radio :label="0">{{type == "buyer"?'渠道':'代理'}}不可见</el-radio>
						<el-radio :label="1">{{type == "buyer"?'渠道':'代理'}}可见</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'memo',
		data() {
			return {
				form: {
					trade_no: JSON.parse(JSON.stringify(this.checkobj.trade_no)),
					mark: "",
					memo: "",
					memo_show: ""
				},

				type: "",
			}
		},

		props: {
			checkobj: {
				type: Object,
				default: {}
			},
		},

		mounted() {
			if (this.$route.path.indexOf("seller") != -1) {
				this.type = "seller";
			} else if (this.$route.path.indexOf("buyer") != -1) {
				this.type = "buyer";
			}

			if (this.type == "buyer") {
				this.form.mark = this.checkobj.buyer_mark;
				this.form.memo = this.checkobj.buyer_memo;
				this.form.memo_show = this.checkobj.buyer_memo_show_seller;
			}

			if (this.type == "seller") {
				this.form.mark = this.checkobj.seller_mark;
				this.form.memo = this.checkobj.seller_memo;
				this.form.memo_show = this.checkobj.seller_memo_show_buyer;
			}


		},

		inject: ['appdata'],

		methods: {
			ondata() {
				var obj = {};
				if (this.type == "buyer") {
					obj.buyer_mark = this.form.mark;
					obj.buyer_memo = this.form.memo;
					obj.buyer_memo_show_seller = this.form.memo_show;
				}

				if (this.type == "seller") {
					obj.seller_mark = this.form.mark;
					obj.seller_memo = this.form.memo;
					obj.seller_memo_show_buyer = this.form.memo_show;
				}

				obj.trade_no = this.form.trade_no;
				this.$emit('ondata', obj)
			}
		}
	}
</script>

<style scoped lang="less">
	// .mhead {
	// 	width: 100%;
	// 	height: 30px;
	// 	font-size: 14px;
	// 	display: flex;
	// 	align-items: center;
	// 	justify-content: center;
	// 	margin-bottom: 50px;
	// 	span {
	// 		margin-right: 20px;
	// 	}
	// }

	.colorradio {

		// display: flex;
		// align-items: center;
		// justify-content: flex-start;
		/deep/ .el-radio-group {
			display: flex;
			align-items: center;
			height: 40px;
		}

		/deep/ .el-radio {
			display: flex;
			align-items: center;
		}
	}

	.colorbox {
		width: 20px;
		height: 20px;
		border: 1px solid #000;
	}
</style>



// WEBPACK FOOTER //
// src/common/memo.vue